import * as React from 'react';
import { lazyInject } from '../../services/inversify';
import { RechteService } from '../../services/rechte_service';
import formStyle from '../forms/style/WForm.less';
import { WFormFieldText, WFormFieldMail, WFormFieldPassword } from '../forms/WFormFramework';
import { WActionButton } from '../elements/WActionButton';
import { Md5 } from 'ts-md5/dist/md5';


interface WRechteZugangProps extends React.ClassAttributes<any> {
    modul: string;
    stamp: number;
    rechteBasis: any;
    costumClass?: string;
    formLayout?: string;
    onDataChange?: () => void;
}

interface WRechteZugangState {
    userData: any;
    userRechteLists: any;
    userGroupsLists: any;
}

export class WRechteZugang extends React.Component<WRechteZugangProps, WRechteZugangState> {

    constructor(props: any) {
        super(props);

        this.state = {
            userData: null,
            userRechteLists: {},
            userGroupsLists: {}
        };

        this.loadUserData = this.loadUserData.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    @lazyInject(RechteService) private rechteService: RechteService;
    private passOld: string = null;

    componentDidMount() {
        if (!this.state.userData) {
            this.loadUserData();
        }
    }

    componentDidUpdate(preProps: any, preState: any) {
        if (preProps.stamp !== this.props.stamp) {
            this.loadUserData();
        }
    }

    loadUserData() {
        const rechteBasis = this.props.rechteBasis;
        if (rechteBasis.currentUser &&
            Array.isArray(rechteBasis.entity_user) &&
            Array.isArray(rechteBasis.group_items) &&
            Array.isArray(rechteBasis.access) &&
            Array.isArray(rechteBasis.access_user)) {

            const user = rechteBasis.currentUser;
            const userFound = rechteBasis.entity_user.find((iu: any) => {
                return iu.login === user;
            });

            if (userFound) {
                const userData: any = {
                    tid: userFound.tid,
                    login: userFound.login,
                    pass: userFound.pass,
                    pass_repeat: '',
                    Mail: userFound.Mail,
                    groupList: [],
                    rechteList: []
                };
                this.passOld = userData.pass;
                // rechteBasis.group_items.map((igi: any) => {
                //     if (igi.name === userData.login) {
                //         userData.groupList.push(igi.group_tid);
                //     }
                // });
                userData.rechteList = this.rechteService.getUserEffctivRechte(user);
                this.setState({ userData });
                // console.log(userData);
            }
        }
    }

    render() {
        return (
            <div
                className={formStyle.sidebysideWIPSsmall}
                style={{ maxWidth: '650px' }}
            >
                <div
                    className={formStyle.formcontainer}
                    style={{ minHeight: '550px', minWidth: '650px' }}
                >
                    <div>
                        <WFormFieldText
                            label={<div className={formStyle.label}>Anmeldename</div>}
                            name='login'
                            value={this.state.userData ? this.state.userData.login : ''}
                            disabled={true}
                            onValueChange={() => { }}
                        />

                        <WFormFieldPassword
                            label={<div className={formStyle.label}>Passwort</div>}
                            name='pass'
                            value={this.state.userData ? this.state.userData.pass : ''}
                            onValueChange={(name: string, value: any) => {
                                const userData = this.state.userData;
                                userData.pass = value;
                                this.setState({ userData });
                            }}
                        />

                        <WFormFieldPassword
                            label={<div className={formStyle.label}>Passwort wiederholen</div>}
                            name='pass_repeat'
                            value={this.state.userData ? this.state.userData.pass_repeat : ''}
                            disabled={this.state.userData && this.passOld && this.state.userData.pass !== this.passOld ? false : true}
                            onValueChange={(name: string, value: any) => {
                                const userData = this.state.userData;
                                userData.pass_repeat = value;
                                this.setState({ userData });
                            }}
                        />

                        <WFormFieldMail
                            label={<div className={formStyle.label}>E-Mail-Adresse</div>}
                            name='Mail'
                            value={this.state.userData ? this.state.userData.Mail : ''}
                            onValueChange={(name: string, value: any) => {
                                const userData = this.state.userData;
                                userData.Mail = value;
                                this.setState({ userData });
                            }}
                        />

                        <div className={formStyle.fieldBox}>
                            <div className={formStyle.label}>Effektive Rechte</div>
                            <div className={formStyle.input}>
                                <textarea
                                    style={{ width: '290px', height: '200px', resize: 'none', padding: '5px' }}
                                    rows={10}
                                    disabled={true}
                                    value={this.state.userData ? this.state.userData.rechteList.join('\n') : ''}
                                />
                            </div>
                        </div>

                        <div style={{ textAlign: 'right' }}>
                            <WActionButton
                                label='Speichern'
                                key='formSave'
                                action='formSave'
                                onAction={this.onSave}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    onSave() {
        // console.log(this.state.userData);
        const userData = this.state.userData;
        let pass = userData.pass;
        if (pass === '') {
            alert('Passwort darf nicht leer sein.');
            return;
        } else if (this.passOld !== pass) {
            if (pass !== userData.pass_repeat) {
                alert('Passwörter stimmt nicht überein');
                return;
            }
            pass = Md5.hashAsciiStr(pass).toString();
        }
        if (userData.tid > 0) {
            this.rechteService.saveUser(userData.tid, pass, userData.Mail, () => {
                alert('Daten wurden gespeichert.');
                if (typeof this.props.onDataChange === 'function') {
                    this.props.onDataChange();
                }
            });
        }
    }
}
